import { render, staticRenderFns } from "./face.vue?vue&type=template&id=2050b026&scoped=true"
import script from "./face.vue?vue&type=script&lang=js"
export * from "./face.vue?vue&type=script&lang=js"
import style0 from "./face.vue?vue&type=style&index=0&id=2050b026&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050b026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2050b026')) {
      api.createRecord('2050b026', component.options)
    } else {
      api.reload('2050b026', component.options)
    }
    module.hot.accept("./face.vue?vue&type=template&id=2050b026&scoped=true", function () {
      api.rerender('2050b026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/face.vue"
export default component.exports